import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useDashboardService } from 'src/apis/dashboard/useDashboardService';
import { IStudentsDashboardData } from 'src/apis/dashboard/dashboardStudents.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getDashboardStudentsKey = 'get-dashboard-students';

export const useDashboardStudentsHook = (
  options?: UseQueryOptions<IStudentsDashboardData, TQueryError>
): UseQueryResult<IStudentsDashboardData, TQueryError> => {
  const { getStudentDashboardData } = useDashboardService();

  return useQuery<IStudentsDashboardData, TQueryError>({
    queryKey: [getDashboardStudentsKey],
    queryFn: () => getStudentDashboardData(),
    enabled: true,
    ...options,
  });
};
